export default "__VITE_ASSET__DT2GxmFI__"